import React from 'react';

import {
    Form, Icon, Input, Button, Checkbox, Card, Modal
} from 'antd';

import {
    Link
} from 'react-router-dom';
import { Redirect } from 'react-router';

import config from './config.json';
import $ from 'jquery';

import './App.css';
import queryString from 'query-string';

const FormItem = Form.Item;

const Authentication =
    {
        token: "",
        isValid: false
    };

let timeout = null;
let loginName = '';

class LoginForm extends React.Component {

    static GetAuth() {
        return Authentication;
    }

     static ValidateServerToken(onLogout, onLogin = null) {
         // if query is used
        //if (query) {
        //    const token = queryString.parse(query).token;
        //    console.log(token);

        //    // this is in case you are logging in via only url.
        //    if (Authentication.token === "") {
        //        Authentication.token = token;
        //    }
        //}

        console.log('validating this page....');

        // validate async
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/login/validate`,
            data: { Token: Authentication.token }
        })
        .done((data) => {
            console.log(data);
            if( data.Message === "Valid")  {
                Authentication.isValid = true;
                //Authentication.token = data.Token;
                //this.props.history.push(`${url}?token=${Authentication.token}`);
                if (onLogin) {
                    onLogin();
                }
            }
                // logout
            else if (data.Message === "InValid") {
                //window.location.assign(config.clientHomeUrl + '/login');
                Authentication.isValid = false
                onLogout();
            }
        })
        .fail((jqXhr) => {
            console.log('failed to connect to server');
            //window.location.assign(config.clientHomeUrl + '/login');
            onLogout();
        });
    }

    state = {
        username: '',
        password: '',
        login: false
     }

    constructor(props)
    {
        super(props);


    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });
    }

    handleSelectChange = (value) => {
        // console.log(value);
        this.props.form.setFieldsValue({
            note: value
        });
    }

    render() {
        //const { getFieldDecorator } = this.props.form;
        
        return (
            <div className="col-xs-12">
                {!this.state.login ?
                    <section className="form">
                        <div className="content-container">
                            <h1>Login</h1>
                            <p>You are entering the <a href="https://www.dot.nd.gov/">Department of Transportation</a> Certification Administration System.</p>
                            <p>Enter your Login ID and password:</p>
                            <form className="login-form">
                                <p className="table-row">
                                    <label className="table-cell">Login ID:</label>
                                    <input className="form-control text-box single-line login" type="text"
                                        value={this.state.username}
                                        onChange={({ target }) => { this.setState({ username: target.value }); loginName = target.value; }} />
                                </p>
                                <p className="table-row">
                                    <label className="table-cell">Password:</label>
                                    <input className="form-control text-box single-line login" type="password"
                                        value={this.state.password}
                                        onChange={({target}) => { this.setState({ password: target.value }) }} />
                                </p>

                                {/*<Link to="/admin/admin" className="btn btn-default">Login</Link>*/}

                                <button className="btn btn-default" onClick={this.validateLogin}> Login</button>
                            </form>
                        </div>
                    </section>
                    : <Redirect to="/admin/admin" replace />}
            </div>
        );
    }

    validateLogin = (e) => {
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/login/authenticate`,
            data: { UserNameID: this.state.username, Password: this.state.password }
        })
        .done((data) => {
            console.log(data);
            if (data.Message === "Authenticated")
            {
                Authentication.token = data.Token;
                Authentication.isValid = true;
                this.props.onLogin();
                this.setState({ login: true });
                // create timeout function
                if (timeout !== null) {
                    clearInterval(timeout);
                }

                timeout = setInterval(() => {
                    $.ajax({
                        type: 'POST',
                        url: `${config.serverUrl}/api/login/validate`,
                        data: { Token: Authentication.token }
                    }).done((data) => {
                        //console.log(data);
                        //console.log('keep alive');
                    
                    })
                }, 60 * 1000);
            }
            else
            {
                Authentication.isValid = false;
                this.setState({ login: false });
                const modal1 = Modal.error({
                    title: "Authentication Failure",
                    content: 'Authentication failed! Please try again.',
                    onOk() {
                        window.location.reload();
                    }
                });
            }
        })
        .fail((jqXhr) => {
            console.log('failed to connect to server');
            console.log(jqXhr);
            });

        e.preventDefault();
    }

    componenDidMount() {
      
    }

    static getTimeout()
    {
        return timeout;
    }

    static getUsername()
    {
        return loginName
    }
}

//const WrappedNormalLoginForm = Form.create()(LoginForm);

//export default WrappedNormalLoginForm;

export default LoginForm;



// WEBPACK FOOTER //
// ./src/LoginForm.js